jQuery(document).ready(function ($) {
  // certificate image
  $(".certificate-img-wrapper").slick({
    dots: false,
    nav: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  });

  // upper testimonial
  $(".upperTestimonial").slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: "linear",
    slidesToShow: 3,
    draggable: true,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    // variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // lower testimonial
  $(".lowerTestimonial").slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: "linear",
    draggable: true,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    // variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // function initBlogSlider() {
  //   if ($(window).width() > 991) {
  //     if (!$(".home-blog-list").hasClass("slick-initialized")) {
  //       $(".home-blog-list").slick({
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         arrows: true,
  //         dots: false,
  //         speed: 300,
  //         infinite: false,
  //         autoplaySpeed: 5000,
  //         autoplay: false,
  //       });
  //     }
  //   } else {
  //     if ($(".home-blog-list").hasClass("slick-initialized")) {
  //       $(".home-blog-list").slick("unslick");
  //     }
  //   }
  // }

  // Initialize on page load
  // initBlogSlider();

  // Reinitialize on window resize
  // $(window).on("resize", function () {
  //   initBlogSlider();
  // });

  $(".blog_galler_wrapp").slick();

  // tab js
  // Show the first tab and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  // show hide in resgister page.
  $(".eye-view").on("click", function () {
    $(this)
      .closest(".field")
      .find("input[type='password']")
      .attr("type", "text");
    $(this).hide();
    $(this).siblings(".eye-hide").show();
  });

  $(".eye-hide").on("click", function () {
    $(this)
      .closest(".field")
      .find("input[type='text']")
      .attr("type", "password");
    $(this).hide();
    $(this).siblings(".eye-view").show();
  });

  $("#ContactForm #ContactForm-phone, #address_form_new #AddressPhoneNew").on(
    "input",
    function () {
      var inputValue = $(this).val();
      var sanitizedValue = inputValue.replace(/[^0-9]/g, ""); // Keep only numeric digits
      sanitizedValue = sanitizedValue.slice(0, 15); // Limit to a maximum of 15 digits
      $(this).val(sanitizedValue);
    }
  );

  $(".accordion details").on("click", function () {
    $(".accordion details").not(this).removeAttr("open");
  });

  // $("header-drawer").on("click", function () {
  //   $("html").toggleClass("toogle-active");
  // });

    $("header-drawer").on("click", function () {   
      $("html").addClass("toogle-active");
      setTimeout(function(){      
          if ( !$('.menu-drawer-container').hasClass('menu-opening')) {
             $("html").removeClass("toogle-active");
          }
      }, 750);     
    });



  
  // tabbed content
  // Hide all tab content initially
  $(".tab_content").hide();

  // Show the first tab's content by default
  $(".tab_content:first").show();

  /* Handle click event for tabs */
  $("ul.tabs li").click(function () {
    // Hide all tab contents
    $(".tab_content").hide();

    // Get the active tab's identifier
    var activeTab = $(this).attr("rel");

    // Show the content for the clicked tab
    $("#" + activeTab).fadeIn();

    // Remove the active class from all tabs and add to the clicked tab
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    // Remove the active class from all drawer headings and add to the corresponding one
    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
  });

  /* Handle click event for drawer mode (mobile) */
  $(".tab_drawer_heading").click(function () {
    // Hide all tab contents
    $(".tab_content").hide();

    // Get the active drawer tab's identifier
    var d_activeTab = $(this).attr("rel");

    // Show the content for the clicked drawer tab
    $("#" + d_activeTab).fadeIn();

    // Remove the active class from all drawer headings and add to the clicked one
    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    // Remove the active class from all tabs and add to the corresponding one
    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  });

  /* Add a border to the last tab */
  $("ul.tabs li").last().addClass("tab_last");
});


jQuery(document).ready(function(){
  if(jQuery(window).width() < 1201) {
   $('a#HeaderDrawer-about-us').on('click', function (e) {  
  
        $('.header__icon--menu').trigger('click'); // Trigger click on the close icon
        $('.header__icon--menu').click();
    });
  };
});




document.querySelectorAll('.shopify-policy__container').forEach(el => {
  el.classList.remove('shopify-policy__container');
  el.classList.add('page-width', 'page-width--narrow');
});












